import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-lg border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://readdy.ai/api/search-image?query=modern%20minimalist%20tech%20logo%20design%20for%20code%20linter%20tool%20featuring%20abstract%20geometric%20shapes%20with%20cyan%20and%20purple%20gradient%20colors%2C%20clean%20lines%2C%20circular%20or%20hexagonal%20form%20representing%20unity%20and%20connection%2C%20professional%20software%20development%20brand%20identity%2C%20simple%20icon%20on%20transparent%20or%20dark%20background%2C%20vector%20style%20illustration&width=120&height=120&seq=bellibutton-logo-v2&orientation=squarish" 
              alt="Bellibutton Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-white text-xl font-mono font-bold">bellibutton</span>
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-400 hover:text-[#00d9ff] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-400 hover:text-[#00d9ff] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('documentation')}
              className="text-gray-400 hover:text-[#00d9ff] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Documentation
            </button>
            <button
              onClick={() => scrollToSection('usage')}
              className="text-gray-400 hover:text-[#00d9ff] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              Usage
            </button>
            <button
              onClick={() => scrollToSection('license')}
              className="text-gray-400 hover:text-[#00d9ff] transition-colors duration-200 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              License
            </button>
            <a
              href="https://github.com/yeswayjosue/bellibutton"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-white/5 hover:bg-white/10 px-4 py-2 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-github-fill text-white text-lg"></i>
              <span className="text-white text-sm font-medium">GitHub</span>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
